import { Component, ChangeDetectorRef, Input } from '@angular/core';
import { ThemeService } from '@themes';
import { StateService, States } from '@state';
import { Config } from '@config';

@Component({
    selector: 'cl-footer',
    template: `
        <footer>
            <a class="logo" *ngIf="showFooterLogo"></a>
            <h2 class="contact-headline" i18n="@@footer.contact.headline" disable-empty format-text markdown-content>null</h2>
            <span class="contact" i18n="@@footer.contact.text" disable-empty format-text markdown-content>null</span>
            <span
                *ngIf="defaultDisclaimer"
                class="disclaimer"
                i18n="@@footer.disclaimer.text"
                [format-text]="{ linebreaks : false }" markdown-content>© Siemens AG 2013 - {{copyrightYear}} All Rights Reserved</span>
            <span
                *ngIf="!defaultDisclaimer"
                class="disclaimer"
                i18n="@@footer.landing.page.disclaimer.text"
                [format-text]="{ linebreaks : false }"  markdown-content>© Siemens AG 2013 - {{copyrightYear}} All Rights Reserved</span>
            <footer-navigation [cookieLink]="cookieLink"></footer-navigation>
            <h2 i18n="@@footer.hotline.headline" disable-empty format-text  markdown-content>null</h2>
            <span i18n="@@footer.hotline.text" disable-empty format-text  markdown-content>null</span>
        </footer>
    `,
    standalone: false
})
export class CLFooter {
    constructor(
        public themeDataService: ThemeService,
        private stateService: StateService,
        public config: Config,
        private changeDetection: ChangeDetectorRef
    ) {
        const date = new Date();
        const year = date.getFullYear();
        this.copyrightYear = year;
        this.subscription = this.stateService
            .values([States.isLoggedOutOutlet, States.themeConfig])
            .subscribe((result: any) => {
                if (result.themeConfig) {
                    this.showFooterLogo = result.themeConfig.showFooterLogo ? true : false;
                    if (result.themeConfig.landingPageDisclaimer && result.isLoggedOutOutlet === true) {
                        this.defaultDisclaimer = false;
                    }else{
                        this.defaultDisclaimer = true;
                    }
                    this.copyrightYear = year;
                }
            },  true);
    }

    private subscription: any;

    public showFooterLogo: boolean = false;

    public defaultDisclaimer: boolean = true;

    public copyrightYear: number;

    @Input()
    public cookieLink: string;

    public ngOnDestroy() {
        this.stateService.unsubscribe(this.subscription);
    }
}
